import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, TextField, Typography } from "@material-ui/core";

import ModalSolicitud from "./ModalSolicitud";
import { cancelarSolicitud } from "../services/bibliotecaApi";

/**
 * El solicitante cancela su solicitud mientras siga abierta. No se puede
 * deshacer, por eso se confirma aparte. El motivo es obligatorio y queda en
 * el historial; el backend tambien lo exige.
 */
const ModalCancelar = ({ solicitud, onCerrar, onCancelada, onMensaje }) => {
  const [mensaje, setMensaje] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [sinMotivo, setSinMotivo] = useState(false);

  const cancelar = async () => {
    if (!mensaje.trim()) {
      setSinMotivo(true);
      return;
    }
    setEnviando(true);
    const { ok, titulo } = await cancelarSolicitud(solicitud.id, mensaje.trim());
    onMensaje(titulo, ok ? "success" : "info");
    if (!ok) {
      setEnviando(false);
      return;
    }
    onCancelada();
  };

  return (
    <ModalSolicitud
      titulo="¿ Cancelar Solicitud ?"
      ancho="sm"
      onCerrar={onCerrar}
      acciones={
        <Button color="secondary" disabled={enviando} onClick={cancelar}>
          {enviando ? "Cancelando..." : "Sí, cancelar"}
        </Button>
      }
    >
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Tu solicitud de {solicitud.tipo_solicitud?.nombre} quedará cancelada y
        no podrás reactivarla. Si la necesitas después, tendrás que radicar una
        nueva.
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={2}
        margin="normal"
        required
        label="Motivo de la cancelación"
        value={mensaje}
        error={sinMotivo}
        helperText={sinMotivo ? "Escribe por qué cancelas la solicitud" : ""}
        onChange={({ target }) => {
          setMensaje(target.value);
          setSinMotivo(false);
        }}
      />
    </ModalSolicitud>
  );
};

ModalCancelar.propTypes = {
  solicitud: PropTypes.shape({
    id: PropTypes.number.isRequired,
    tipo_solicitud: PropTypes.object,
  }).isRequired,
  onCerrar: PropTypes.func.isRequired,
  onCancelada: PropTypes.func.isRequired,
  onMensaje: PropTypes.func.isRequired,
};

export default ModalCancelar;
